import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-privacity',
  templateUrl: './modal-privacity.component.html',
  styleUrl: './modal-privacity.component.scss'
})
export class ModalPrivacityComponent {

  @Input() form!: FormGroup;
  @Input() controlName!: string;

  constructor(public activateModal: NgbActiveModal) { }

  close() {
    this.activateModal.close();
  }

}
